<template>
  <div class="add-student">
    <a-modal
      :visible="visible"
      :title="createTitle"
      :width="472"
      centered
      wrap-class-name="create-group-modal"
      :mask-closable="false"
      :ok-text="okText"
      :destroy-on-close="true"
      :confirm-loading="confirmLoading"
      :closable="false"
      :z-index="103"
      @cancel="handleCancel"
      @ok="handleCreateStudent"
    >
      <div class="content">
        <!-- form表单 -->
        <a-form-model
          class="form"
          ref="ruleForm1"
          :model="form"
          :rules="rules"
          :label-col="labelCol"
          :wrapper-col="wrapperCol"
          label-align="left"
        >
          <a-form-model-item
            ref="name"
            label="学员姓名"
            name="name"
            prop="name"
            col="3"
            allow-clear
          >
            <a-auto-complete
              v-model="form.name"
              :data-source="studentNameList"
              :placeholder="studentNamePlaceholder"
              :open="showStudentNameDropDown"
              @focus="onFocusStudentName"
              @blur="onBlurStudentName"
              @select="onSelectStudentName"
              ref="studentName"
            />
          </a-form-model-item>

          <a-form-model-item
            ref="telephone"
            label="家长电话"
            name="telephone"
            prop="telephone"
            allow-clear
          >
            <a-col :span="6">
              <a-select
                class="select"
                :value="activeParentId"
                @change="handleParentChange"
              >
                <a-select-option :value="item.id" v-for="item in parentRefList" :key="item.name">
                  {{ item.name }}
                </a-select-option>
              </a-select>
            </a-col>
            <a-col :span="18">
              <a-input
                v-model="form.telephone"
                placeholder="请输入"
                max-length="11"
              />
            </a-col>
          </a-form-model-item>

          <a-form-model-item label="在校年级" prop="gradeId" allow-clear>
            <a-select
              class="select"
              :value="form.gradeId"
              @change="handleGradeChange"
            >
              <a-select-option :value="''">
                请选择
              </a-select-option>
              <a-select-option :value="item.id" v-for="item in gradeDataList" :key="item.name">
                {{ item.name }}
              </a-select-option>
            </a-select>
          </a-form-model-item>

          <a-form-model-item label="性别" allow-clear>
            <a-radio-group v-model="form.sex">
              <a-radio :value="1">
                男
              </a-radio>
              <a-radio :value="2">
                女
              </a-radio>
            </a-radio-group>
          </a-form-model-item>

          <a-form-model-item ref="school" label="出生日期" allow-clear>
            <a-date-picker placeholder="请选择" value-format="YYYY-MM-DD" />
          </a-form-model-item>

          <a-form-model-item ref="school" label="所在学校" allow-clear>
            <a-input
              v-model="form.school"
              placeholder="请输入"
            />
          </a-form-model-item>
        </a-form-model>
        <div class="password-tip">
          学员默认密码为 axx+手机号后六位，创建后请及时联系学员修改密码。
        </div>
        <template slot="footer">
          <a-button key="cancel" @click="handleCancel">
            取消
          </a-button>
          <a-button type="primary" @click="handleCreateStudent">
            确定
          </a-button>
        </template>
      </div>
    </a-modal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { debounce } from 'lodash'

const validateName = (rule, value, callback) => {
  const _len = value.length
  if (!/^[\u4e00-\u9fa5_a-zA-Z0-9]+$/.test(value)) {
    callback(new Error('请输入学员姓名，限制为汉字、数字、英语'))
  } else if (_len > 10) {
    callback(new Error('长度不能超过15'))
  } else {
    callback()
  }
}
const validateTelephone = (rule, value, callback) => {
  if (!/^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/.test(value)) {
    callback(new Error('请输入正确的手机号'))
  } else {
    callback()
  }
}
const validateGradeId = (rule, value, callback) => {
  if (value === -1) {
    callback(new Error('请选择年级'))
  } else {
    callback()
  }
}
const SUBJECTS = {
  ZH: 'zh',
  EN: 'en',
  MATH: 'math',
  PY: 'physical'
}

const parentRef = [
  { id: 0, name: '父亲' },
  { id: 1, name: '母亲' },
  { id: 2, name: '其他' }
]

export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      createStuVisible: true, // 新建学员弹窗：是否展示
      createTitle: '添加新学员', // 新建学员弹窗：标题
      confirmLoading: false,
      activeParentId: 0, // 学员家长
      gradeDataList: [],
      activeGradeId: '', // 班级ID
      parentRefList: parentRef,
      confirmVisible: false, // 气泡确认框

      birthDate: '', // 出生日期
      // form 设置
      labelCol: { span: 4 },
      wrapperCol: { span: 20 },
      other: '',
      form: {
        name: '',
        telephone: '',
        sex: '',
        school: '',
        gradeId: '',
        birthday: '',
        [SUBJECTS.ZH]: {
          bookversion: undefined,
          rank: undefined
        },
        [SUBJECTS.MATH]: {
          bookversion: undefined,
          rank: undefined
        },
        [SUBJECTS.EN]: {
          bookversion: undefined,
          rank: undefined
        },
        [SUBJECTS.PY]: {
          bookversion: undefined,
          rank: undefined
        }
      },
      rules: {
        telephone: [
          { required: true, trigger: 'blur', validator: validateTelephone }
        ],
        name: [
          { required: true, trigger: 'change', validator: validateName }
        ],
        gradeId: [
          { required: true, trigger: 'change', validator: validateGradeId }
        ]
      },
      exitModalVisible: true,
      addLoading: false,
      backValue: '',
      isEditing: false,
      // 当前手机号下的学员列表
      studentNameListOfPhone: [],
      // 展示下拉框
      showStudentNameDropDown: false
    }
  },

  created() {
    // this.init()
    window.onmousewheel = this.onmousewheel
  },
  methods: {
    ...mapActions({
      getGradeList: 'common/getGradeList'
    }),

    /**
     * 重置数据
     */
    resetData() {
      this.form = {
        name: '',
        telephone: '',
        sex: '',
        school: '',
        gradeId: '',
        birthday: ''
      }
      this.activeParentId = 0
      this.parentTel1 = ''
    },
    handleParentChange(id) {
      this.activeParentId = id
    },
    handleGradeChange(id) {
      this.activeGradeId = id
      this.form.gradeId = id
    },
    /**
     * 取消
     */
    handleCancel() {
      // this.exitModalVisible = false
      this.$emit('update:visible', false)
    },
    /**
     * 新增学员
     */
    handleCreateStudent() {
      const ref = this.parentRefList[this.activeParentId].name
      if (this.form.gradeId < 0) {
        this.$message.error('请选择年级')
        return
      }
      this.$service.groupManage.addNewStudent({
        name: this.form.name,
        gradeId: this.form.gradeId,
        sex: this.form.sex,
        birthday: this.form.birthday,
        school: this.form.school,
        parent1ref: ref,
        parentTel1: this.form.telephone
      }).then(res => {
        console.log('res', res)
        if (res) {
          this.$message.success('添加成功')
          this.$emit('update:visible', false)
          this.$emit('addStudentSuccess', res)
        }
      }).catch(e => {
      })
    },

    // onBack(val) {
    //   this.backValue = val
    //   if (this.isEditing) {
    //     this.exitModalVisible = true
    //   } else {
    //     this.handleCreateStudent()
    //   }
    // },
    async init() {
      const res = await this.$service.common.getGradeList()
      if (res) {
        this.gradeDataList = res.gradeList
      }
    },
    onFocusStudentName(val) {
      if (this.studentNameListOfPhone?.length > 0) {
        this.showStudentNameDropDown = true
      } else {
        this.showStudentNameDropDown = false
      }
    },

    onBlurStudentName() {
      this.showStudentNameDropDown = false
    },

    onSelectStudentName() {
      this.$nextTick(() => { this.showStudentNameDropDown = false })
    },

    onmousewheel: debounce(function() {
      this.onBlurStudentName()
    }, 200, { leading: true })
  },
  computed: {
    ...mapGetters({
      gradeList: 'common/gradeList'
    }),
    studentNameList() {
      return this.studentNameListOfPhone?.map(item => item.studentName) || []
    },
    studentNamePlaceholder() {
      return this.studentNameList.length > 0 ? '手机号下已有学员，可选择或输入' : '请输入'
    }
  },
  watch: {
    async visible(val) {
      if (val) {
        this.resetData()
      }
    },
    form: {
      deep: true,
      handler(val) {
        this.isEditing = true
      }
    },
    'form.telephone'(nVal, oVal) {
      const self = this
      if (nVal.length === 11) {
        this.$refs.ruleForm1.validateField('telephone')
      }
      validateTelephone(null, nVal, err => {
        if (err) {
          self.studentNameListOfPhone = []
        }
      })
    },
    'form.school'(nVal, oVal) {
      let tempVal = nVal.replace(/[^\u4e00-\u9fa5a-zA-Z0-9]+/g, '')
      if (tempVal.length > 50) {
        tempVal = tempVal.slice(0, 50)
      }
      this.form.school = tempVal
    },
    studentNameList(val) {
      if (val?.length > 0) {
        this.$refs.studentName.focus()
        this.showStudentNameDropDown = true
      } else {
        this.showStudentNameDropDown = false
      }
    }
  },
  mounted() {
    // this.init()
    this.getGradeList()
    this.init()
  }
}
</script>

<style lang="less" scoped>
@import '~@/static/css/base.less';

.add-student {
  display: flex;
  flex-direction: column;
  width: 100%;
  .content {
    padding: 40px;
    height: 100%;
    background-color: #ffffff;
    overflow-y: auto;

    .steps {
      width: 244px;
      margin: auto;
    }
    .form {
      width: 480px;
      margin: 38px auto 0;
      .pre-btn, .next-btn {
        width: 107px;
      }
      .select,
      .ant-select {
        width: 100px;
      }
      :deep(.ant-form-item-label > label::after){
        display: none;
      }
      .version-title {
        margin-bottom: 4px;
      }
      .tips {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        padding: 16px 12px;
        background: #FFF8E5;
        border-radius: 6px;
        line-height: 20px;
        margin-bottom: 6px;
        .title {
          display: inline-flex;
          align-items: center;
          white-space: nowrap;
          i {
            color: @yellow-0;
            margin-right: 4px;
          }
          i + span {
            font-weight: bold;
          }
        }
      }
    }
  }
}
.password-tip {
  font-size: 13px;
  color: #98A2B3 !important;
}
</style>